var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"pt-0 text-caption text-right",attrs:{"cols":"12","align-self":"start"}},[_c('v-icon',{staticClass:"text-red",attrs:{"x-small":""}},[_vm._v("mdi-asterisk")]),_vm._v(" — Required Fields ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }